export default {
  fill: 'I18N_ACTIONS_FILL'
}
